"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backgroundServerFunctionList = exports.backgroundLocalFunctionList = exports.batchBackgroundServerFunctionList = void 0;
__exportStar(require("./components/CheckAudioClippingLocal"), exports);
__exportStar(require("./components/SegmentAudioLocal"), exports);
__exportStar(require("./components/ArrayFilterLocal"), exports);
__exportStar(require("./components/BgAPIUserLocationComponent"), exports);
__exportStar(require("./components/NullCheckLocal"), exports);
__exportStar(require("./components/BgLocalArrayPushComponent"), exports);
__exportStar(require("./components/BgLocalCheckEligibilityComponent"), exports);
__exportStar(require("./components/BgLocalCheckInRangeComponent"), exports);
__exportStar(require("./components/BgLocalFetchDistrictNamesComponent"), exports);
__exportStar(require("./components/BgLocalIncrementIntComponent"), exports);
// Batch background server function list for autotransform batch components
exports.batchBackgroundServerFunctionList = {
    TO_UPPER: 'To Upper Case (Batch)',
    ACS: 'Azure Cognitive Services Transcription',
    SEGMENTED_TRANSCRIPTION: 'Segmented Transcription',
    INDIC_CONFORMER_BATCH: 'Indic-Conformer Batch Transcription',
};
exports.backgroundLocalFunctionList = {
    CHECK_AUDIO_CLIPPING: 'Check Clipping',
    SEGMENT_AUDIO: 'Automatic audio segmentation',
    ARRAY_FILTER: 'Array Filtering',
    NULL_CHECK: 'Null Check',
    GET_USER_LOCATION: 'Get User Location',
    INCREMENT_INT: 'Increment Integer',
    FETCH_DISTRICT_NAMES: 'Fetch District Names',
    CHECK_IN_RANGE: 'Check Value in Range',
    CHECK_ELIGIBILITY: 'Check Eligibility',
    ARRAY_PUSH: 'Array Push',
};
// Background server function list for autotransform components
exports.backgroundServerFunctionList = {
    TO_UPPER: 'To Upper Case',
    CHECK_GENDER: 'Check the Gender',
    COMPUTE_PAYMENT: 'Compute Payment',
    DUAL_CHANNEL_TO_MONO: 'Dual Channel to Mono',
    // Add more BACKGROUND_SERVER functions here as they are implemented
};
//# sourceMappingURL=Index.js.map